import cn from 'classnames';
import PropTypes, { elementType } from 'prop-types';
import { DynamicComponent } from 'ui';
import { childrenType, colorType } from 'utils/types';

const TypographyPage = ({
  children, className, as = 'div', dense, blog = false, color, ...attrs
}) => (
  <DynamicComponent className={cn(className, 'typography-page', {
    'typography-page--dense': dense,
    'typography-page--blog': blog,
    [`typography-page--${color}`]: color,
  })} tag={as} {...attrs}>
    {children}
  </DynamicComponent>
);

TypographyPage.propTypes = {
  children: childrenType,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  dense: PropTypes.bool,
  as: PropTypes.oneOfType([elementType, PropTypes.string]),
  color: colorType,

};

export default TypographyPage;
